import styled from "@emotion/styled";
import classNames from "classnames";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";

import { DesignToken } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { withVar } from "themes/helpers";

const StyledOption = styled.label<{ disabled: boolean }>`
  display: inline-flex;
  margin-bottom: 20px;
  width: 100%;
  cursor: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.disabled ? "default" : "pointer")
  };
  opacity: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.disabled ? "0.5" : "1")
  };

  .circle {
    position: relative;
    width: 16px;
    height: 16px;
    border-radius: 16px;
    background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
    border: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
    margin-right: 10px;
    transition: all 0.2s ease;
    box-sizing: border-box;
    margin-top: 1px;

    .inner-circle {
      opacity: 0;
      position: absolute;
      top: 4px;
      left: 4px;
      width: 6px;
      height: 6px;
      border-radius: 6px;
      background-color: ${withVar(DesignToken.ActionPrimaryDefault)};
      transition: inherit;
    }

    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => (props.disabled ? "default" : "auto")
      };
    }
  }

  &.selected > .circle {
    border-color: ${withVar(DesignToken.ActionPrimaryDefault)};

    .inner-circle {
      opacity: 1;
    }
  }
`;

interface IProps {
  error?: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const RadioOption: React.FC<IProps> = ({ error, children, className, ...props }) => (
  <div>
    {/* @ts-expect-error TS(2322) */}
    <StyledOption className={classNames({ selected: props.checked }, className)} disabled={props.disabled}>
      <div className="circle">
        <span className="inner-circle" />
        <input type="radio" {...props} />
      </div>
      <Block flex="1">{children}</Block>
      {error && <span className="field-error">{error}</span>}
    </StyledOption>
  </div>
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RadioOptionFinalForm: React.FC<FieldRenderProps<any, HTMLElement>> = ({ input, meta, ...props }) => (
  <RadioOption error={meta && meta.submitFailed && meta.error} {...input} {...props} />
);
